module.exports = "/dist/montserrat-latin-400.svg?8ebd6e279bdebe637550c059ff43a0b8";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-400.svg
// module id = 72
// module chunks = 0